import client from '.spat/modules/client';
// sentry
import * as Sentry from "@sentry/browser";
// for Performance monitoring
// import { BrowserTracing } from "@sentry/tracing";

var environment = spat.config.sentry.environment;
if (environment) {
  Sentry.init({
    dsn: "https://5f030324f66c4167b621e92dcde1a165@o889670.ingest.sentry.io/6259488",
    // for Performance monitoring
    // integrations: [new BrowserTracing()],
    // tracesSampleRate: 0.2,
    environment,
  });

}
global.Sentry = Sentry;

client.showSSR();

app.data.init().then(() => {
  client.start();
}).catch((err) => {
  console.error(err);
  window.alert('エラーが発生しました、リロードをお願いします');
  location.reload();
});
